import { useEffect, useState } from "react";
import Progress from "../Progress";
import "./Skillbar.css";

function Skillbar({ skill }) {
  const [done, setDone] = useState(0);
  console.log(skill, "asd");
  useEffect(() => {
    // setTimeout(() => {
    //   if (skill.level > done) setDone(done + 1);
    // }, 20);
    setDone(skill.level);
  }, [done, skill.level]);

  return (
    <div className="skillBar">
      <span className="skillBar__name">{skill.name}</span>
      <Progress done={done} />
    </div>
  );
}

export default Skillbar;
